import { z } from "zod";

export const useFormSchema = () => {
  return z.object({
    id: z.string().optional(),
    checklist_user_name: z.string().optional(),
    started_at: z.date().optional(),
    finished_at: z.date().optional(),
  });
};
